<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <v-autocomplete
          label="Épület"
          v-model="search.building_ids"
          :items="buildings"
          item-text="name"
          item-value="id"
          filled
          clearable
          @click:clear="search.building_level_ids = []"
          :value-comparator="$config.comparators.isEqual"
          multiple
        />
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-autocomplete
          label="Kapu"
          v-model="search.gate_ids"
          :items="gates"
          item-text="name"
          item-value="element_id"
          :value-comparator="$config.comparators.isEqual"
          filled
          clearable
          multiple
        />
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-autocomplete
          label="Zóna"
          v-model="search.zone_ids"
          :items="zones"
          item-text="name"
          item-value="element_id"
          :value-comparator="$config.comparators.isEqual"
          filled
          clearable
          multiple
        />
      </v-col>

      <v-col cols="12" md="6" lg="3">
        <v-autocomplete
          label="Esemény"
          v-model="search.events"
          :items="eventTypes"
          filled
          clearable
          multiple
        >
          <template #item="{ item }">
            <!-- <v-icon :color="item.color" left>mdi-circle</v-icon>
            <span>{{ item.text }}</span> -->
            <v-chip small :color="item.color">{{ item.text }}</v-chip>
          </template>
          <!-- <template #selection="{ item }">
            <v-chip small :color="item.color" class="mt-2">{{ item.text }}</v-chip>
          </template> -->
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :options="options"
      :items="accessLog"
      :footer-props="$config.dataTableFooterProps">
      <template #[`item.created`]="{ item }">
        <span :title="item.created">
          {{ item.created | moment('lll') }}
        </span>
      </template>

      <template #[`item.event`]="{ item }">
        <!-- <v-chip
          :color="resolveEventName(item).color"
          dark
          :title="resolveEventName(item).tooltip"
          >{{ resolveEventName(item).title }}</v-chip
        > -->
        <div class="d-flex align-center">
          <v-icon left :color="resolveEventName(item).color">{{
            resolveEventName(item).icon
          }}</v-icon>
          <span>{{ resolveEventName(item).title }}</span>
        </div>
      </template>

      <template #[`item.location`]="{ item }">
        <span>{{ item.building_name }} - {{ item.building_level_name }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let sseSource = null;

export default {
  props: {
    cardId: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      search: {
        building_ids: [],
        gate_ids: [],
        zone_ids: [],
        events: [],
      },
      accessLog: [],
      options: {
        sortBy: ['created', 'id'],
        sortDesc: [true, true],
      },
    };
  },

  watch: {
    search: {
      handler() {
        if (sseSource) {
          sseSource.close();
          sseSource = null;
        }

        this.accessLog = [];

        // Check browser support for SSE
        if (typeof EventSource !== 'undefined') {
          this.loading = true;
          const params = new URLSearchParams();
          params.append('token', this.$store.state.token);
          params.append('gate_ids', this.search.gate_ids);
          params.append('building_ids', this.search.building_ids);
          params.append('events', this.search.events);
          params.append('zone_ids', this.search.zone_ids);

          sseSource = new EventSource(
            `${process.env.VUE_APP_API_URL}cards/access-log/${this.cardId}?${params.toString()}`
          );
          sseSource.onmessage = (event) => {
            const data = JSON.parse(event.data);
            this.accessLog.push(...data.access_log);
            this.loading = false;
          };
        } else {
          console.warn('Sorry, no support for server-sent events.');
        }
      },
      immediate: true,
      deep: true,
    },
  },

  beforeDestroy() {
    if (sseSource) {
      sseSource.close();
      sseSource = null;
      console.log('beforeDestroy', sseSource);
    }
  },

  methods: {
    resolveEventName(item) {
      if (item.event.plate) {
        switch (item.event.eventType) {
          case 'LEGAL_CARD_PASS':
            return {
              icon: 'mdi-car',
              color: 'success',
              title: `Áthaladás ${item.event.plate} rendszámmal`,
            };
          case 'PLATE_NO_RIGHT':
            return {
              icon: 'mdi-car-off',
              color: 'error',
              title: `Rendszámnak nincs jogosultsága: ${item.event.plate}`,
              tooltip: 'A rendszámnak nem volt jogosultsága az kapu nyitásához',
            };
        }
      } else {
          switch (item.event) {
          case 'INVALID_CARD':
            return {
              icon: 'mdi-card-off-outline',
              color: 'error',
              title: 'Érvénytelen kártya',
              tooltip: 'A kártya nem volt rajta a kontrolleren',
            };
          case 'CARD_INVALID_PERIOD':
            return {
              icon: 'mdi-clock-remove-outline',
              color: 'error',
              title: 'Érvénytelen időszak',
              tooltip: 'Érvényes időszakon kívüli belépési kísérlet',
            };
          case 'CARD_NO_RIGHT':
            return {
              icon: 'mdi-close-octagon-outline',
              color: 'error',
              title: 'Nincs jogosultság',
              tooltip: 'A kártyának nem volt jogosultsága az ajtó nyitásához',
            };
          case 'LEGAL_CARD_PASS':
            if (item.direction === 'I') {
              return {
                icon: 'mdi-login-variant',
                color: 'success',
                title: `Belépés ${item.zone_name} zónába`,
              };
            } else if (item.direction === 'O') {
              return {
                icon: 'mdi-logout-variant',
                color: 'warning',
                title: `Kilépés ${item.zone_name} zónából`,
              };
            }
            return {
              icon: 'mdi-login-variant',
              color: 'success',
              title: 'Áthaladás',
            };
          default:
            return item.event;
        }
      }
    },
  },

  computed: {
    headers() {
      return [
        { text: 'Idő', value: 'created', sortable: true },
        { text: 'Esemény', value: 'event', sortable: false },
        { text: 'Lokáció', value: 'location', sortable: false },
        { text: 'Kapu', value: 'gate_name', sortable: false },
      ];
    },

    eventTypes() {
      return [
        //'INVALID_CARD', 'CARD_INVALID_PERIOD', 'CARD_NO_RIGHT', 'LEGAL_CARD_PASS'
        { text: 'Érvénytelen kártya', value: 'INVALID_CARD', color: 'error' },
        { text: 'Érvénytelen időszak', value: 'CARD_INVALID_PERIOD', color: 'error' },
        { text: 'Nincs jogosultság', value: 'CARD_NO_RIGHT', color: 'error' },
        { text: 'Áthaladás', value: 'LEGAL_CARD_PASS', color: 'success' },
      ];
    },
  },

  asyncComputed: {
    buildings: {
      async get() {
        const response = await this.$http.get('buildings/list');
        return response.buildings;
      },
      default: [],
    },

    gates: {
      async get() {
        const response = await this.$http.post('gates/list', { limit: 9999 });
        return response.gates;
      },
      default: [],
    },

    zones: {
      async get() {
        const response = await this.$http.post('zones/list', { limit: 9999 });
        return response.zones;
      },
      default: [],
    },
  },
};
</script>
